import { TEST_DRIVE_APPROVAL_QUIZ_INTERFACE } from "../../constants/quizInterfaces";
import { isAnsweredWithTestDriveApproval } from "../../utils/quiz-selection-count";
import { allChildrenAnswered } from "../../utils/quiz-view-tracker";
import {
  TEST_DRIVE_APPROVAL_QUESTION_ID,
  TEST_DRIVE_APPROVAL_PARENT_QUESTION_ID,
} from "../../constants/questionIds";
import { submitTestDriveApproval } from "../../utils/quiz-submit-utils";
import { ANL_ID } from "../../constants/dealershipIds";
import { createQuestionViewIndexMapping } from "../../utils/createQuestionViewIndexMapping";

export const ANLTestDrivePreApprovalQuestions = [
  {
    viewText: "Test Drive and Pre-Approval",
    viewSubtext: "",
    header: "Test Drive",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return window.location.pathname === `${ANL_ID}/testdrive`;
    },
    visitedOnce: false,
    automaticForward: false,
    submit: submitTestDriveApproval,
    disabled: false,
    disable: function (disable = true) {
      const currentQuestionView =
        this[questionViewIndexMapping[TEST_DRIVE_APPROVAL_PARENT_QUESTION_ID]];
      if (currentQuestionView.children[0].prefilled) {
        return disable;
      } else {
        return false;
      }
    },
    responses: function () {
      return {
        testDriveApproval: this.children[0].testDriveApproval,
        financePreApproval: this.children[0].financePreApproval,
        applicantDetails: this.children[0].applicantDetails,
        // dateOfBirth: this.children[0].dateOfBirth,
        // employmentStatus: this.children[0].employmentStatus,
        // sinNumber: this.children[0].sinNumber,
        // experience: this.children[0].experience,
        // signature : this.children[0].signature,
        additionalNotes: this.children[0].additionalNotes,
        testDriveApprovalDetails: this.children[0].testDriveApprovalDetails,
      };
    },
    questionViewId: TEST_DRIVE_APPROVAL_PARENT_QUESTION_ID,
    children: [
      {
        text: "",
        subtext: "",
        selectionRange: { minimumSelection: 4, maximumSelection: 4 },
        currSelected: [],
        prefill: function (testDriveFinancePreApprovalInfo) {
          if (!testDriveFinancePreApprovalInfo) return;
          this.prefilled = true;
          this.financePreApproval =
            testDriveFinancePreApprovalInfo?.financePreApproval || false;
          this.testDriveApproval =
            testDriveFinancePreApprovalInfo?.testDriveApproval || false;
          this.prefilled = this?.financePreApproval || this?.testDriveApproval;
          this.additionalNotes =
            testDriveFinancePreApprovalInfo?.additionalNotes || "";
          this.applicantDetails =
            testDriveFinancePreApprovalInfo?.applicantDetails || [{}];
          this.testDriveApprovalDetails =
            testDriveFinancePreApprovalInfo?.testDriveApprovalDetails || {
              customerInfo: { name: "", address: "", phone: "" },
              vehicleInfo: {
                year: "",
                make: "",
                model: "",
                stock: "",
                demonstrationLicencePlate: "",
              },
              testDrivePeriod: {
                dateOut: "",
                timeOut: "",
                dateReturnBy: "",
                timeReturnBy: "",
              },
            };
        },
        applicantDetails: [{}],
        // dateOfBirth : "",
        // employmentStatus : "",
        // sinNumber : "",
        // experience : "",
        // signature : "",
        additionalNotes: "",
        testDriveApprovalDetails: {
          customerInfo: { name: "", address: "", phone: "" },
          vehicleInfo: {
            year: "",
            make: "",
            model: "",
            stock: "",
            demonstrationLicencePlate: "",
          },
          testDrivePeriod: {
            dateOut: "",
            timeOut: "",
            dateReturnBy: "",
            timeReturnBy: "",
          },
        },
        testDriveApproval: false,
        financePreApproval: false,
        quizInterface: TEST_DRIVE_APPROVAL_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        prefilled: false,
        isAnswered: isAnsweredWithTestDriveApproval,
        childQuestionId: TEST_DRIVE_APPROVAL_QUESTION_ID,
      },
    ],
  },
];

const questionViewIndexMapping = createQuestionViewIndexMapping(
  ANLTestDrivePreApprovalQuestions
);
